import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsxs("g", {
        children: [
            /*#__PURE__*/ _jsx("mask", {
                id: "b",
                width: "36",
                height: "36",
                x: "6",
                y: "6",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ _jsx("path", {
                    fill: "#FECFAA",
                    d: "M6 39.5v-31C6 6.5 7.6667 6 8.5 6h31c2 0 2.5 1.6667 2.5 2.5v31c0 2-1.6667 2.5-2.5 2.5h-31c-2 0-2.5-1.6667-2.5-2.5"
                })
            }),
            /*#__PURE__*/ _jsxs("g", {
                mask: "url(#b)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        fill: "#D6F5BD",
                        d: "M6 6h36v36H6z"
                    }),
                    /*#__PURE__*/ _jsx("circle", {
                        cx: "8.0836",
                        cy: "7.5225",
                        r: "18",
                        fill: "#71C72F"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fill: "#64AE2D",
                        d: "M58.4789 7.9395c0 9.9411-8.0589 18-18 18s-18-8.0589-18-18 8.0589-18 18-18 18 8.0588 18 18"
                    }),
                    /*#__PURE__*/ _jsx("circle", {
                        cx: "7.5211",
                        cy: "40.3379",
                        r: "18",
                        fill: "#A0DF6F"
                    }),
                    /*#__PURE__*/ _jsx("circle", {
                        cx: "40.3477",
                        cy: "40.1992",
                        r: "18",
                        fill: "#58953F"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fill: "#326709",
                        d: "M25.7796 27.1648c-.3785.1622-.8112.2704-1.2438.2704s-.8652-.0541-1.1897-.2163q-.5678-.2434-.9734-.6489c-.2704-.2704-.4867-.649-.6489-1.0275s-.2163-.8652-.2163-1.2979c0-.4867.0541-.9193.2163-1.3519s.3785-.7571.6489-1.0275q.4056-.4056.9734-.6489c.3786-.1622.7571-.2163 1.1897-.2163.3786 0 .8112.0541 1.1897.2163.3786.1622.703.3785.9194.6489l-.9194 1.0275c-.1081-.2163-.2704-.3245-.4867-.4326q-.3245-.1623-.6489-.1623t-.6489.1623c-.2163.1081-.3786.2163-.5408.3785s-.2704.3786-.3245.5949c-.054.2163-.1081.4867-.1081.757s.0541.5408.1081.7571c.0541.2163.2164.4326.3245.5949.1622.1622.3245.2704.4867.3785q.3245.1622.6489.1622c.2704 0 .4867-.054.703-.1622.2163-.1081.3786-.2704.4867-.4326l.9734.9734c-.2163.2704-.5408.5408-.9193.703"
                    })
                ]
            })
        ]
    }, "0"),
    /*#__PURE__*/ _jsx("defs", {}, "1")
], "AppCampaignDebugger", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
